// const userScope = 'user:read:email';
const adminScope = 'user:read:email+chat:read+chat:edit+channel:read:redemptions+bits:read+channel:read:subscriptions';

const userScope = 'openid%20user_read';

const currentUrl = window.location.href;
let redirectUrl = `${window.location.origin}/`;

if (utils.isLocal()) {
  redirectUrl = `${window.location.origin}/application/`;
}

// const userAuthorizeUrl = `https://api.twitch.tv/kraken/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}&scope=${userScope}`;
// const adminAuthorizeUrl = `https://api.twitch.tv/kraken/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}&scope=${adminScope}`;

const userAuthorizeUrl = `https://id.twitch.tv/oauth2/authorize?client_id=${clientId}&redirect_uri=${redirectUrl}&response_type=code&scope=${userScope}`;
const adminAuthorizeUrl = `https://id.twitch.tv/oauth2/authorize?client_id=${clientId}&redirect_uri=${redirectUrl}&response_type=code&scope=${adminScope}`;

let loggedInUrl = `${window.location.origin}/dashboard`;

if (utils.isLocal()) {
  loggedInUrl = `${window.location.origin}/application/dashboard`;
}



(function() {
  window.authentication = {
    login: function() {

      if (window.location.host == 'dev.sgtwoofy.com') {
        return;
      }

      const code = window.location.search ? utils.url.param({url: currentUrl, name: 'code'}) : null;

      if (code) {
        authentication.showLoading();
        authentication.getAccessToken({code: code});
      }
    },
    showLoading: function() {
      $('[data-button="twitch"]').addClass('is-hidden');
      $('[data-button="loading"]').addClass('is-visible');
    },
    logout: function() {
      utils.cookies.deleteAll();
      userService.logout()
      .then(function (response) {
        if (utils.isLocal()) {
          window.location.href = '/application';
        } else {
          window.location.href = '/';
        }
      })
      .catch(function (error) {
        //console.log(error);
      });
    },
    getAccessToken: function({code}) {
      userService.getToken({redirectUrl: redirectUrl, code: code})
        .then(function (response) {
          utils.cookies.set('access_token', response.data.access_token);
          authentication.getTwitchUserInfo();
          // authentication.refreshAccessToken({callback: function() {
          //   authentication.getTwitchUserInfo();
          // }});
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    refreshAccessToken: function({callback}) {
      userService.refreshToken()
        .then(function (response) {
          utils.cookies.set('access_token', response.data.access_token);
          // utils.cookies.set('expires_in', response.data.expires_in);
          // utils.cookies.set('refresh_token', response.data.refresh_token);
          //authentication.updateUser({redirect: false});
          callback();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getTwitchUserInfo: function() {
      axios.get(`${apiUrl}users`, {
          headers: utils.requests.getHeaders({token: utils.cookies.get('access_token')})
        })
        .then(function (response) {
          utils.cookies.set('user_id', response.data.data[0].id);
          utils.cookies.set('user_login', response.data.data[0].login);
          utils.cookies.set('user_display_name', response.data.data[0].display_name);
          utils.cookies.set('user_email', response.data.data[0].email);
          utils.cookies.set('user_profile_image', response.data.data[0].profile_image_url);
          authentication.getUser();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    getUser: function() {
      userService.get()
        .then(function (response) {
          console.log(response);
          utils.cookies.set('theme', response.data.theme);
          utils.cookies.set('user_role', response.data.role);
          if (response.data.role === 'mod' || response.data.role === 'streamer' || response.data.role === 'admin') {
            utils.cookies.set('channelId', response.data.channelId);
          } 
          authentication.updateUser({redirect: true});
        })
        .catch(function (error) {
          authentication.createUser();
        });
    },
    createUser: function() {
      userService.create()
        .then(function (response) {
          
          //utils.cookies.set('id', response.data.id);
          window.location.href = loggedInUrl;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    updateUser: function({redirect}) {
      userService.update()
        .then(function (response) {
          if (redirect) {
            window.location.href = loggedInUrl;
          }
        })
        .catch(function (error) {
          //console.log(error);
        });
    }
  }
})();

$(function() {
  $('[data-button="twitch"]').attr('href', userAuthorizeUrl);
  $('[data-button="twitch-admin"]').attr('href', adminAuthorizeUrl);
});